import videojs from "video.js";
import backwardIcon from "../../../assets/images/player/backward.svg"

class BackwardButtonOverlay extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-skip-backward-overlay custom-control');

        // Add button click listener
        this.on('click', () => {
            player.currentTime(Math.max(0, player.currentTime() - 10)); // Skip backward 10 seconds
        });
    }

    createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-skip-backward-overlay custom-control',
            innerHTML: `<img src="${backwardIcon}"/>`
        });
    }
}

videojs.registerComponent('BackwardButtonOverlay', BackwardButtonOverlay);